import React from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Experience from './components/Experience';
import Contact from './components/Contact';

function App() {
  return (
    <div className="dark bg-background text-on-background min-h-screen">
      <Navigation />
      <main>
        <Hero />
        <Experience />
        <Contact />
      </main>
      <footer className="border-t border-white/5 bg-surface-container-lowest py-16">
        <div className="flex flex-col md:flex-row justify-between items-center max-w-[1100px] mx-auto px-8 gap-8">
          <span className="text-label-sm text-on-surface-variant/40 uppercase tracking-widest">
            © 2026 Nick Bitzer
          </span>
          <div className="flex gap-8">
            <a
              href="https://www.linkedin.com/in/nick-bitzer"
              target="_blank"
              rel="noopener noreferrer"
              className="text-label-sm uppercase tracking-widest text-on-surface-variant/40 hover:text-primary transition-colors"
            >
              LinkedIn
            </a>
            <a
              href="https://github.com/nbitzer"
              target="_blank"
              rel="noopener noreferrer"
              className="text-label-sm uppercase tracking-widest text-on-surface-variant/40 hover:text-primary transition-colors"
            >
              GitHub
            </a>
            <a
              href="mailto:nick@bitzer.me"
              className="text-label-sm uppercase tracking-widest text-on-surface-variant/40 hover:text-primary transition-colors"
            >
              Email
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
